"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var newLineHelper_1 = require("./newLineHelper");
var StringHelper = /** @class */ (function () {
    function StringHelper() {
    }
    StringHelper.BulletedList = function (items, indentCharacter, bulletCharacter) {
        if (indentCharacter == null) {
            indentCharacter = "";
        }
        if (bulletCharacter == null) {
            bulletCharacter = "●";
        }
        var indentBullet = "\n" + indentCharacter + bulletCharacter;
        indentBullet = newLineHelper_1.default.convertToBreaks(indentBullet);
        var string = indentBullet;
        for (var i = 0; i < items.length; i++) {
            string += items[i];
            if (i < (items.length - 1)) {
                string += indentBullet;
            }
        }
        return string;
    };
    StringHelper.linkify = function (text) {
        var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
        return text.replace(urlRegex, function (url) {
            return '<a href="' + url + '">' + url + '</a>';
        });
    };
    return StringHelper;
}());
exports.default = StringHelper;
//# sourceMappingURL=stringHelper.js.map


/** WEBPACK FOOTER **
 ** ./src/utils/stringHelper.js
 **/